import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getActiveDigitalProductUserPricing,
  getProductPrisingListSelector
} from '../../modules/selectors';
import {
  fetchLaboratoriesAction,
  fetchProductPricingListAction,
  fetchProductUserPricingGroupsListAction,
  fetchUserPricingAction
} from '../../modules/actions';

export const useShopPricingLists = (productPricingListId?: string) => {
  const dispatch = useDispatch();
  const pricingList = useSelector(getProductPrisingListSelector);
  const digitalUserPricings = useSelector(getActiveDigitalProductUserPricing);

  useEffect(() => {
    dispatch(fetchLaboratoriesAction());

    if (!pricingList.length) {
      dispatch(fetchProductPricingListAction());
    }
  }, []);

  useEffect(() => {
    if (
      productPricingListId !== '' &&
      productPricingListId !== undefined &&
      productPricingListId !== null
    ) {
      dispatch(fetchUserPricingAction({ id: productPricingListId }));
      dispatch(fetchProductUserPricingGroupsListAction({ id: productPricingListId }));
    }
  }, [dispatch, productPricingListId]);

  const validatedPricingListValue = useMemo(() => {
    const isValid = pricingList.some((list) => list._id === productPricingListId);

    return isValid ? productPricingListId : '';
  }, [productPricingListId, pricingList]);

  const pricingListOptions = useMemo(
    () => pricingList.map((list) => ({ value: list._id, text: list.name })),
    [pricingList]
  );

  const digitalPricingOptions = useMemo(
    () =>
      digitalUserPricings
        .filter((pricing) => !pricing.allImagesIncluded)
        .sort((a, b) => a.tier - b.tier)
        .map((pricing) => ({
          text: pricing.name || pricing.productName,
          value: pricing._id
        })),
    [digitalUserPricings]
  );

  const isDigitalUserPricingActive = digitalUserPricings.length > 0;

  return {
    pricingList,
    digitalUserPricings,
    isDigitalUserPricingActive,
    validatedPricingListValue,
    pricingListOptions,
    digitalPricingOptions
  };
};
